// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/mafia/MafiaChat.css */

.mafia-chat-container {
  position: fixed;
  /* Растягиваем на весь экран */
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;

  /* Фон на все приложение */
  background: rgba(0, 0, 0, 0.15);

  z-index: 1050;
  display: flex;
  flex-direction: column;
  align-items: center; /* Центрируем контент */
  pointer-events: auto;

}

/* Обертка для контента */
.mafia-chat-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  /* Ограничиваем ширину чата */
  max-width: min(100vw, 75vh);
  height: 100%;
  /* ВАЖНО для скролла внутри flex-колонки (иначе блок может не ужиматься и overflow не сработает) */
  min-height: 0;
  /* Отступ сверху под меню и снизу */
  padding: 60px 10px 10px 10px;
  box-sizing: border-box;
}

.mafia-chat-messages {
  flex: 1 1;

  overflow-y: auto;
  display: flex;
  flex-direction: column;
  /* УДАЛЕНО: justify-content: flex-end; - это ломало скролл */
  /* justify-content: flex-end; */
  gap: 5px;
  padding-bottom: 2px;

  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */
  /* Разрешаем вертикальный скролл жестами */
  touch-action: pan-y !important;
  /* Разрешаем выделение текста в области сообщений */
  user-select: text !important;
  -webkit-user-select: text !important;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  scrollbar-width: none;

}

.mafia-chat-messages * {
  touch-action: pan-y;
}


.mafia-chat-messages::-webkit-scrollbar { display: none; }

/* ДОБАВЛЕНО: Прижимаем сообщения к низу, если их мало, не ломая скролл */
.mafia-chat-messages > :first-child {
  margin-top: auto !important;
}

.mafia-message-row { display: flex; width: 100%; }

/* --- ГРУППИРОВКА СООБЩЕНИЙ --- */
/* Если сообщение является продолжением серии (chained), уменьшаем отступ сверху,
   чтобы компенсировать gap: 5px родителя и визуально объединить пузыри */
.mafia-message-row.chained {
  margin-top: -3px;
}

.my-message { justify-content: flex-end; }
.other-message { justify-content: flex-start; }

.mafia-message-bubble {
  max-width: 80%;
  min-width: 60px;
  padding: 5px 9px;
  border-radius: 11px;
  position: relative;
  word-wrap: break-word;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  opacity: 0.9;
}

.my-message .mafia-message-bubble {
  background-color: var(--tg-theme-button-color, #40a7e3);
  color: var(--tg-theme-button-text-color, #ffffff);
  border-bottom-right-radius: 4px;
  margin-right: 8px;
}

/* Скругление для "хвоста" сообщения, если оно в середине цепочки (опционально для красоты) */
.my-message.chained .mafia-message-bubble {
    border-top-right-radius: 4px; /* Верхний угол тоже делаем маленьким для стыковки */
}

.my-message .mafia-message-bubble.drawing-phase {
  opacity: 0.5;
}

.other-message .mafia-message-bubble {
  background-color: var(--tg-theme-secondary-bg-color, #fff);
  color: var(--tg-theme-text-color, #000);
  border-bottom-left-radius: 4px;
  margin-left: 8px;
}

/* Скругление для "хвоста" чужого сообщения в цепочке */
.other-message.chained .mafia-message-bubble {
    border-top-left-radius: 4px;
}

.other-message .mafia-message-bubble.drawing-phase {
  opacity: 0.5;
}


.mafia-message-author {
  font-size: 14px; font-weight: 700; opacity: 0.8; margin-bottom: 2px;
  color: var(--tg-theme-link-color, #2481cc);
}

.mafia-message-text {
  font-size: 15px; line-height: 1.4; white-space: pre-wrap; display: block;
  margin-right: 30px; margin-bottom: 2px; text-align: left;

  /* ИСПРАВЛЕНИЕ 3: Разрешаем выделение текста самого сообщения */
  user-select: text !important;
  -webkit-user-select: text !important;
}

.mafia-message-time {
  font-size: 10px; text-align: right; opacity: 0.7; position: absolute; bottom: 4px; right: 8px; pointer-events: none;
}

/* --- ВВОД ТЕКСТА --- */
.mafia-chat-input-area {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 5px 0 15px 0;
  background: transparent;
  flex-shrink: 0; /* Не даем сжиматься */
}

.mafia-chat-input {
  flex: 1 1;
  height: 44px;
  line-height: 20px;
  padding: 12px 15px;
  border-radius: 22px;
  border: none;
  background: var(--tg-theme-bg-color, #fff);
  color: var(--tg-theme-text-color, #000);
  font-size: 16px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  outline: none;
  font-family: inherit;
  resize: none;
  overflow-y: auto;
  box-sizing: border-box;
}

.mafia-chat-input::-webkit-scrollbar { display: none; }

.mafia-chat-send-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  background: var(--tg-theme-button-color, #40a7e3);
  color: var(--tg-theme-button-text-color, #fff);
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  transition: transform 0.1s;
  flex-shrink: 0;
}

.mafia-chat-send-btn:active {
  transform: scale(0.95);
}

/* Добавляем стили для режима призрака */

.mafia-chat-container.ghost-view {
  /* Перекрываем холст полностью сплошным фоном */
  background-color: var(--tg-theme-bg-color, #ffffff) !important;
  z-index: 1000 !important; /* Убеждаемся, что чат поверх холста */
}

/* Опционально: немного затемняем фон сообщений призраков, чтобы отличалось визуально */
.ghost-view .other-message .mafia-message-bubble {
  background-color: var(--tg-theme-secondary-bg-color);
  opacity: 0.7;
}

/* Разделитель раундов */
.mafia-chat-divider {
  width: 100%;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: var(--tg-theme-hint-color, #888);
  margin: 3px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.mafia-chat-divider::before,
.mafia-chat-divider::after {
  content: '';
  flex: 1 1;
  border-bottom: 1px solid var(--tg-theme-hint-color, #ccc);
  margin: 0 15px;
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/components/mafia/chat/MafiaChat.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,eAAe;EACf,8BAA8B;EAC9B,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;;EAEZ,0BAA0B;EAC1B,+BAA+B;;EAE/B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,uBAAuB;EAC5C,oBAAoB;;AAEtB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,kGAAkG;EAClG,aAAa;EACb,mCAAmC;EACnC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,SAAO;;EAEP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4DAA4D;EAC5D,+BAA+B;EAC/B,QAAQ;EACR,mBAAmB;;EAEnB,gBAAgB,EAAE,uDAAuD;EACzE,0CAA0C;EAC1C,8BAA8B;EAC9B,mDAAmD;EACnD,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,4BAA4B;EAC5B,qBAAqB;;AAEvB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,0CAA0C,aAAa,EAAE;;AAEzD,yEAAyE;AACzE;EACE,2BAA2B;AAC7B;;AAEA,qBAAqB,aAAa,EAAE,WAAW,EAAE;;AAEjD,kCAAkC;AAClC;yEACyE;AACzE;EACE,gBAAgB;AAClB;;AAEA,cAAc,yBAAyB,EAAE;AACzC,iBAAiB,2BAA2B,EAAE;;AAE9C;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uDAAuD;EACvD,iDAAiD;EACjD,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,6FAA6F;AAC7F;IACI,4BAA4B,EAAE,oDAAoD;AACtF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0DAA0D;EAC1D,uCAAuC;EACvC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;IACI,2BAA2B;AAC/B;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,eAAe,EAAE,gBAAgB,EAAE,YAAY,EAAE,kBAAkB;EACnE,0CAA0C;AAC5C;;AAEA;EACE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,cAAc;EACxE,kBAAkB,EAAE,kBAAkB,EAAE,gBAAgB;;EAExD,+DAA+D;EAC/D,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,eAAe,EAAE,iBAAiB,EAAE,YAAY,EAAE,kBAAkB,EAAE,WAAW,EAAE,UAAU,EAAE,oBAAoB;AACrH;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,qBAAqB;EACrB,uBAAuB;EACvB,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,uCAAuC;EACvC,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,uCAAuC,aAAa,EAAE;;AAEtD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;EACjD,8CAA8C;EAC9C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wCAAwC;;AAExC;EACE,+CAA+C;EAC/C,8DAA8D;EAC9D,wBAAwB,EAAE,sCAAsC;AAClE;;AAEA,uFAAuF;AACvF;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,yDAAyD;EACzD,cAAc;EACd,YAAY;AACd","sourcesContent":["/* src/components/mafia/MafiaChat.css */\n\n.mafia-chat-container {\n  position: fixed;\n  /* Растягиваем на весь экран */\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n\n  /* Фон на все приложение */\n  background: rgba(0, 0, 0, 0.15);\n\n  z-index: 1050;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* Центрируем контент */\n  pointer-events: auto;\n\n}\n\n/* Обертка для контента */\n.mafia-chat-content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  /* Ограничиваем ширину чата */\n  max-width: min(100vw, 75vh);\n  height: 100%;\n  /* ВАЖНО для скролла внутри flex-колонки (иначе блок может не ужиматься и overflow не сработает) */\n  min-height: 0;\n  /* Отступ сверху под меню и снизу */\n  padding: 60px 10px 10px 10px;\n  box-sizing: border-box;\n}\n\n.mafia-chat-messages {\n  flex: 1;\n\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  /* УДАЛЕНО: justify-content: flex-end; - это ломало скролл */\n  /* justify-content: flex-end; */\n  gap: 5px;\n  padding-bottom: 2px;\n\n  overflow-y: auto; /* Добавляем вертикальную прокрутку при необходимости */\n  /* Разрешаем вертикальный скролл жестами */\n  touch-action: pan-y !important;\n  /* Разрешаем выделение текста в области сообщений */\n  user-select: text !important;\n  -webkit-user-select: text !important;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  scrollbar-width: none;\n\n}\n\n.mafia-chat-messages * {\n  touch-action: pan-y;\n}\n\n\n.mafia-chat-messages::-webkit-scrollbar { display: none; }\n\n/* ДОБАВЛЕНО: Прижимаем сообщения к низу, если их мало, не ломая скролл */\n.mafia-chat-messages > :first-child {\n  margin-top: auto !important;\n}\n\n.mafia-message-row { display: flex; width: 100%; }\n\n/* --- ГРУППИРОВКА СООБЩЕНИЙ --- */\n/* Если сообщение является продолжением серии (chained), уменьшаем отступ сверху,\n   чтобы компенсировать gap: 5px родителя и визуально объединить пузыри */\n.mafia-message-row.chained {\n  margin-top: -3px;\n}\n\n.my-message { justify-content: flex-end; }\n.other-message { justify-content: flex-start; }\n\n.mafia-message-bubble {\n  max-width: 80%;\n  min-width: 60px;\n  padding: 5px 9px;\n  border-radius: 11px;\n  position: relative;\n  word-wrap: break-word;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.15);\n  display: flex;\n  flex-direction: column;\n  opacity: 0.9;\n}\n\n.my-message .mafia-message-bubble {\n  background-color: var(--tg-theme-button-color, #40a7e3);\n  color: var(--tg-theme-button-text-color, #ffffff);\n  border-bottom-right-radius: 4px;\n  margin-right: 8px;\n}\n\n/* Скругление для \"хвоста\" сообщения, если оно в середине цепочки (опционально для красоты) */\n.my-message.chained .mafia-message-bubble {\n    border-top-right-radius: 4px; /* Верхний угол тоже делаем маленьким для стыковки */\n}\n\n.my-message .mafia-message-bubble.drawing-phase {\n  opacity: 0.5;\n}\n\n.other-message .mafia-message-bubble {\n  background-color: var(--tg-theme-secondary-bg-color, #fff);\n  color: var(--tg-theme-text-color, #000);\n  border-bottom-left-radius: 4px;\n  margin-left: 8px;\n}\n\n/* Скругление для \"хвоста\" чужого сообщения в цепочке */\n.other-message.chained .mafia-message-bubble {\n    border-top-left-radius: 4px;\n}\n\n.other-message .mafia-message-bubble.drawing-phase {\n  opacity: 0.5;\n}\n\n\n.mafia-message-author {\n  font-size: 14px; font-weight: 700; opacity: 0.8; margin-bottom: 2px;\n  color: var(--tg-theme-link-color, #2481cc);\n}\n\n.mafia-message-text {\n  font-size: 15px; line-height: 1.4; white-space: pre-wrap; display: block;\n  margin-right: 30px; margin-bottom: 2px; text-align: left;\n\n  /* ИСПРАВЛЕНИЕ 3: Разрешаем выделение текста самого сообщения */\n  user-select: text !important;\n  -webkit-user-select: text !important;\n}\n\n.mafia-message-time {\n  font-size: 10px; text-align: right; opacity: 0.7; position: absolute; bottom: 4px; right: 8px; pointer-events: none;\n}\n\n/* --- ВВОД ТЕКСТА --- */\n.mafia-chat-input-area {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 5px 0 15px 0;\n  background: transparent;\n  flex-shrink: 0; /* Не даем сжиматься */\n}\n\n.mafia-chat-input {\n  flex: 1;\n  height: 44px;\n  line-height: 20px;\n  padding: 12px 15px;\n  border-radius: 22px;\n  border: none;\n  background: var(--tg-theme-bg-color, #fff);\n  color: var(--tg-theme-text-color, #000);\n  font-size: 16px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n  outline: none;\n  font-family: inherit;\n  resize: none;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.mafia-chat-input::-webkit-scrollbar { display: none; }\n\n.mafia-chat-send-btn {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  border: none;\n  background: var(--tg-theme-button-color, #40a7e3);\n  color: var(--tg-theme-button-text-color, #fff);\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n  transition: transform 0.1s;\n  flex-shrink: 0;\n}\n\n.mafia-chat-send-btn:active {\n  transform: scale(0.95);\n}\n\n/* Добавляем стили для режима призрака */\n\n.mafia-chat-container.ghost-view {\n  /* Перекрываем холст полностью сплошным фоном */\n  background-color: var(--tg-theme-bg-color, #ffffff) !important;\n  z-index: 1000 !important; /* Убеждаемся, что чат поверх холста */\n}\n\n/* Опционально: немного затемняем фон сообщений призраков, чтобы отличалось визуально */\n.ghost-view .other-message .mafia-message-bubble {\n  background-color: var(--tg-theme-secondary-bg-color);\n  opacity: 0.7;\n}\n\n/* Разделитель раундов */\n.mafia-chat-divider {\n  width: 100%;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--tg-theme-hint-color, #888);\n  margin: 3px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.mafia-chat-divider::before,\n.mafia-chat-divider::after {\n  content: '';\n  flex: 1;\n  border-bottom: 1px solid var(--tg-theme-hint-color, #ccc);\n  margin: 0 15px;\n  opacity: 0.3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
